/**
 * @function formatGriffinAddressMeta
 * @param {object} address
 * @description Griffin address metadata uses the name `postcode`, but
 * xobuyernodeserv expects it to be named `postalCode`.
 */
const formatGriffinAddressMetadata = address => {
  const { layout = [], strings = {} } = address;

  /**
   * Why are we manipulating the layout?
   * POSTCODE: We get the name from xobuyernodeserv as 'postcode', but when we
   *    send it back to xobuyernodeserv for the onboard call it need to be
   *    postalCode
   * STATE: Griffin sends back the US regex and maxLength for the state field
   *    for a number of non-US countries (e.g. CN/C2, IM, UM, etc). Because of
   *    this, we won't set the pattern attr or the maxLength on the state
   *    field. If we did then any non-US country that got the US states attrs
   *    would fail validation.
   */
  address.layout = layout.map(item => {
    const { maxLength, name, regex } = item;
    const isState = name === 'state';
    const isPostalCode = name === 'postcode';

    return {
      ...item,
      maxLength: isState ? null : maxLength,
      name: isPostalCode ? 'postalCode' : name,
      regex: isState ? null : regex,
    };
  });

  // Need to match the manipulation of `'postcode'` above
  if (strings.hasOwnProperty('postcodeLabel')) {
    strings.postalCodeLabel = strings.postcodeLabel;
    delete strings.postcodeLabel;
  }

  // When we get the state name for prefilling the form it is in all caps,
  // so we need to have the values be in all caps to have it match
  if (strings.stateList) {
    strings.stateList = strings.stateList.map(({ displayText, value }) => ({
      displayText,
      value: value.toUpperCase(),
    }));
  }

  return address;
};

export { formatGriffinAddressMetadata };
